import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import React, { FC, useEffect, useState } from 'react'
import ReactCodeInput from 'react-code-input'

import { useMediaQuery } from '@mui/material'
import { useUserStore } from '../../store/storeUser'
import { theme } from '../../theme'

const props = {
    inputStyle: {
        borderRadius: '100px',
        border: '1px solid #31AD0B',
        height: '40px',
        width: '40px',
        padding: '12px, 0px, 12px, 0px',
        textAlign: 'center',
        marginLeft: '4px',
    },
    inputStyleInvalid: {
        borderRadius: '100px',
        border: '1px solid #CA1616',
        height: '40px',
        width: '40px',
        padding: '12px, 0px, 12px, 0px',
        textAlign: 'center',
        marginLeft: '4px',
    },
}

interface Props {
    code: string
    handleCode: (code: string) => void
    email: string
    onSubmit: () => void
    error?: string
    title?: React.ReactNode
}

export const CodeVerification: FC<Props> = ({
    code,
    handleCode,
    email,
    onSubmit,
    error,
    title,
}) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [timer, setTimer] = useState(59)
    const { email_verify_id, emailVerifyResendCode, isResendCode } = useUserStore((state) => state)

    useEffect(() => {
        if (timer > 0) {
            setTimeout(() => {
                setTimer(timer - 1)
            }, 1000)
        }
    }, [timer])

    useEffect(() => {
        setTimer(59)
    }, [isResendCode])

    const onSubmitResendCode = async () => {
        await emailVerifyResendCode({ email_verify_id })
    }

    return (
        <>
            {title}
            <Typography variant="body2" sx={{ textAlign: 'center', mb: 0, color: '#9195A1' }}>
                Мы прислали код вам на email
            </Typography>
            <Typography
                variant="body2"
                sx={{ textAlign: 'center', mb: 4, color: '#84B007', wordBreak: 'break-all' }}>
                {email}
            </Typography>
            <ReactCodeInput
                {...props}
                type={isMobile ? 'number' : 'text'}
                isValid={!error}
                fields={6}
                id="code"
                name="code"
                onChange={handleCode}
                value={code}
            />

            {error && (
                <Typography variant="body2" sx={{ textAlign: 'center', mt: 2, color: '#DF1818' }}>
                    Неверный код верификации
                </Typography>
            )}
            <Button
                disabled={!(code.length === 6)}
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={onSubmit}>
                Продолжить
            </Button>
            {timer > 0 && (
                <Typography variant="body2" sx={{ textAlign: 'center', mt: 2, color: '#9195A1' }}>
                    Выслать новый код через 00:{`${timer}`.length > 1 ? timer : `0${timer}`}
                </Typography>
            )}
            {timer === 0 && (
                <Button fullWidth variant="text" onClick={onSubmitResendCode}>
                    Выслать новый код
                </Button>
            )}
        </>
    )
}
